import { ComponentProps, SyntheticEvent } from 'react'

import {
  Objectclass,
  StandardUniselection
} from '@yes.technology/react-toolkit'

import { useSiteState } from 'siteState/shared'

import { useFetchYesObjects } from 'yesObject/shared'

import { ArrayFieldValue } from '../../types'

import {
  SelectionOption,
  parseObjectsToOptions,
  parseOptionsToObjects
} from './optionsParser'

import { SelectionMenuOption } from './StandardMultiselectionField'

type StandardUniselectionProps = ComponentProps<typeof StandardUniselection>

type StandardUniselectionFieldProps = {
  onChangeValues: (values: ArrayFieldValue) => void
  selectedOptions: ArrayFieldValue
  filteractionUuid: string
} & Partial<StandardUniselectionProps>

const StandardUniselectionField = ({
  onChangeValues,
  selectedOptions: selectedObjects,
  filteractionUuid,
  heightClass,
  statusClass = 'default',
  ...props
}: StandardUniselectionFieldProps) => {
  const [objectclass] = useSiteState<Objectclass | undefined>(
    'filter-objectclass'
  )

  const { yesObjects, isFetching } = useFetchYesObjects({
    filteractionUuid,
    initialPagination: { limit: 300, offset: 0 },
    showLoading: false,
    interpolationObject: objectclass,
    enabled: !!objectclass
  })

  const onSelect = (
    newSelectedOption?:
      | SelectionMenuOption
      | SyntheticEvent<HTMLInputElement, Event>
  ) => {
    if (!newSelectedOption) {
      onChangeValues([])

      return
    }

    const parsedNewSelectedOptions = parseOptionsToObjects([
      newSelectedOption as SelectionOption
    ])

    onChangeValues(parsedNewSelectedOptions)
  }

  if (typeof selectedObjects === 'string') {
    return null
  }

  const options = parseObjectsToOptions(yesObjects)

  const selectedOptions = parseObjectsToOptions(selectedObjects)

  return (
    <StandardUniselection
      {...props}
      options={options}
      selectedOption={selectedOptions[0]}
      onSelect={onSelect}
      statusClass={isFetching ? 'processing' : statusClass}
      heightClass={heightClass || 'regular'}
    />
  )
}

export default StandardUniselectionField
